import { IconContext } from "react-icons/lib";
import {
  LinkName,
  ProjectActions,
  ProjectBadge,
  ProjectCard,
  ProjectCodeLink,
  ProjectDetails,
  ProjectImage,
  ProjectImageContainer,
  ProjectImpact,
  ProjectLiveLink,
  ProjectMeta,
  ProjectTitle,
  ProjectTransitionImage,
  StackChip,
} from "../../Styled/ProjectStyled/Project.styled";
import { FaGithub, FaLink } from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();

const ProjectCardComponent = ({
  image,
  transitionImage,
  title,
  description,
  codeLink,
  liveLink,
  stack = [],
  vibeTag,
  impact,
}) => {
  const hoverImage = transitionImage || image;

  return (
    <IconContext.Provider value={{ size: "1rem" }}>
      <ProjectCard data-aos="fade-up">
        <ProjectImageContainer>
          <ProjectImage src={image} alt={title} />
          <ProjectTransitionImage src={hoverImage} alt={title} />
        </ProjectImageContainer>
        <ProjectDetails>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <ProjectTitle>{title}</ProjectTitle>
            {vibeTag && <ProjectBadge>{vibeTag}</ProjectBadge>}
          </div>
          <p>{description}</p>
          {!!stack.length && (
            <ProjectMeta>
              {stack.slice(0, 4).map((item) => (
                <StackChip key={item}>{item}</StackChip>
              ))}
              {stack.length > 4 && <StackChip>+{stack.length - 4}</StackChip>}
            </ProjectMeta>
          )}
          {impact && <ProjectImpact>{impact}</ProjectImpact>}
          <ProjectActions>
            <ProjectLiveLink
              href={liveLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLink />
              <LinkName>Live</LinkName>
            </ProjectLiveLink>
            {codeLink && (
              <ProjectCodeLink
                href={codeLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGithub />
                <LinkName>Code</LinkName>
              </ProjectCodeLink>
            )}
          </ProjectActions>
        </ProjectDetails>
      </ProjectCard>
    </IconContext.Provider>
  );
};

export default ProjectCardComponent;